import React, { createContext, useContext, useState, useRef } from "react";


const DragContext = createContext(null);
 
export function DragProvider({ children }) {
  const [hoverTarget, setHoverTarget] = useState(null);
  const draggingNodeIdRef = useRef(null);

  return (
    <DragContext.Provider value={{
      hoverTarget,
      setHoverTarget,
      draggingNodeIdRef,
    }}>
      {children}
    </DragContext.Provider>
  );
}

export function useDragContext() {
  const ctx = useContext(DragContext);
  if (!ctx) {
    throw new Error("useDragContext must be used inside DragProvider");
  }
  return ctx;
}


export function DropZone({ targetKey, onDropHere }) {
  const { hoverTarget,draggingNodeIdRef, setHoverTarget, draggingNodeId } = useDragContext();

  const isActive = hoverTarget === targetKey;

  return (
    <div
      style={{
        height: hoverTarget === targetKey?"18px":"5px",
        background: isActive ? "#1A73E8" : "transparent",
        transition: "background 0.15s ease",
        margin: "4px 0",
        borderRadius: "4px",
      }}
      onDragOver={(e) => {
        e.preventDefault(); // allow drop
        if (draggingNodeIdRef.current) {
          setHoverTarget(targetKey);
        }
      }}
      onDragLeave={() => {
        if (hoverTarget === targetKey) setHoverTarget(null);
      }}
      onDrop={(e) => {
        e.preventDefault();
        setHoverTarget(null);
        onDropHere();
      }}
    ></div>
  );
}

